import React from "react";
import ReactPlayer from "react-player";
import { Zoom } from "react-reveal";

const Video = () => {
  const videoArray = [
    {
      videoLink: "https://www.youtube.com/watch?v=LzTPNayfN24",
      // imgLink: "images/feed-img2.png",
    },
    {
      videoLink: "https://www.youtube.com/watch?v=4qtXR0yQ2Eo",
      // imgLink: "images/feed-img2.png",
    },
    {
      videoLink: "https://www.youtube.com/watch?v=Qv4wYKAax-I",
      // imgLink: "images/feed-img2.png",
    },
    {
      videoLink: "https://www.youtube.com/shorts/90GJ1v5PhXs",
      // imgLink: "images/feed-img2.png",
    },
    {
      videoLink: "https://www.youtube.com/watch?v=pOGXwBACkfQ",
      // imgLink: "images/feed-img2.png",
    },
    {
      videoLink: "https://youtu.be/yJ1YDQJHQv8",
      // imgLink: "images/feed-img2.png",
    },
  ];
  return (
    <div id="Project" className="container-xxl py-4 team">
      <div className="container">
        <div className="text-center">
          <h6 className="section-title bg-white text-center text-primary px-3">
            <Zoom left>Videos</Zoom>
          </h6>
          <Zoom right>
            <h1 className="mb-4 subtitle">Check Our Project</h1>
          </Zoom>
        </div>
        <div className="videoSectionHeight scrollWidth">
          <div className="row p-3">
            {videoArray.map((item, index) => (
              <Zoom>
                <div className="col-xl-4 col-lg-4 col-md-6 px-1 py-1">
                  <ReactPlayer
                    url={item.videoLink}
                    // light={item.imgLink}
                    controls="true"
                    width="100%"
                    playsinline="true"
                    volume="1"
                    pip="true"
                    stopOnUnmount="false"
                  />
                </div>
              </Zoom>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Video;
